<ng-container *ngIf="isMapLoaded$ | async" fmLoadModule="overlay-controls"></ng-container>

<ng-container *ngIf="isMapOptionsLoaded$ | async" fmLoadModule="map-options"></ng-container>

<ng-container *ngIf="isOverlayControlsLoaded$ | async" fmLoadModule="vehicle-driver-panel"></ng-container>

<fm-overlay-side-panel [ngSwitch]="sidePanelContent$ | async">
  <fm-device-health-check-container *ngSwitchCase="ESidePanelContent.DeviceHealthCheck"></fm-device-health-check-container>
  <fm-geofence-form-container *ngSwitchCase="ESidePanelContent.Geofence"></fm-geofence-form-container>
  <fm-ecm-panel-container *ngSwitchCase="ESidePanelContent.Ecm"></fm-ecm-panel-container>
</fm-overlay-side-panel>
